// Pricing — 2026 rebrand, approved mockup wording verbatim.
import { useEffect } from "react";
import { Link } from "react-router-dom";
import MarketingShell from "../components/MarketingShell";
import { track } from "../lib/analytics";

const BOOK = "https://api.leadconnectorhq.com/widget/bookings/jc3-strategy-call";

const ROWS = [
  { name: "Financial Profile Development", desc: "Strategic development of your financial profile with monthly milestone reviews.", price: "$199 onboarding, billed when your roadmap is delivered. Then $149/mo, billed after each month's work", tail: "Invoiced after delivery" },
  { name: "Personal Capital Strategy", desc: "Nothing to pay up front. You are invoiced only after your capital closes.", price: "10% of capital received, $500 minimum, invoiced after your capital closes", tail: "Invoiced after capital closes" },
  { name: "Business Capital Strategy", desc: "Nothing to pay up front. You are invoiced only after your capital closes.", price: "10% of capital received, $500 minimum, invoiced after your capital closes", tail: "Invoiced after capital closes" },
  { name: "Account History Positioning", desc: "Authorized user accounts matched to your profile.", price: "Starting at $497 per authorized user account", checkoutId: "profile-positioning" },
  { name: "Grant Readiness & Research", desc: "Grant research tailored to your business, plus full application preparation.", price: "$497 research + $997 per application", checkoutId: "grant-readiness" },
  { name: "Business Foundation Setup", desc: "Entity formation, EIN, and foundational business setup.", price: "$497 + state fees at cost", checkoutId: "business-foundation" },
];

const slug = (n) => n.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export default function Pricing() {
  useEffect(() => { document.title = "Pricing | JC3 Wealth Legacy Group"; }, []);
  return (
    <MarketingShell>
      <section className="page-head" aria-labelledby="h-pricing">
        <div className="wrap">
          <h1 id="h-pricing" className="display-xl">Pricing</h1>
          <p className="lead dim-dark">Clear pricing. No surprises.</p>
        </div>
      </section>
      <section className="band on-stone" data-testid="pricing-section">
        <div className="wrap">
          <div className="ledger light">
            {ROWS.map((r) => (
              <div className="price-row" key={r.name} data-testid={`pricing-row-${slug(r.name)}`}>
                <div>
                  <p className="h3">{r.name}</p>
                  <p className="small dim-light" style={{ marginTop: "var(--s2)" }}>{r.desc}</p>
                </div>
                <p className="data" style={{ fontWeight: 500 }}>{r.price}</p>
                <div className="row-actions">
                  <a className="textlink" href={`${BOOK}?utm_source=jc3site&utm_medium=booking-cta&utm_content=${encodeURIComponent(r.name)}`} target="_blank" rel="noopener noreferrer" data-testid={`pricing-book-cta-${slug(r.name)}`} onClick={() => track("booking-cta-click", { location: "pricing", product: r.name }, "/pricing")}>Book a consultation</a>
                  {r.checkoutId ? (
                    <Link className="textlink" to={`/checkout?product=${r.checkoutId}`} data-testid={`pricing-pay-cta-${slug(r.name)}`} onClick={() => track("checkout-cta-click", { location: "pricing", product: r.name }, "/pricing")}>Pay online</Link>
                  ) : (
                    <span className="small dim-light">{r.tail}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="after-steps">
            <p className="small dim-light">State filing fees are billed at cost with no markup.</p>
            <a className="action" href={BOOK} target="_blank" rel="noopener noreferrer" onClick={() => track("booking-cta-click", { location: "pricing-footer" }, "/pricing")}>Book a consultation</a>
          </div>
        </div>
      </section>
    </MarketingShell>
  );
}
